(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8252],{

/***/ 9817:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/strategy",
      function () {
        return __webpack_require__(4518);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MethodologyAnchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var steps = [
    {
        step: "01",
        title: "Discovery sprint",
        desc: "2 weeks, fixed price. We scope the problem, audit your data, and produce a written roadmap, cost estimate, and risk register. You decide whether to proceed — no commitment beyond the sprint."
    },
    {
        step: "02",
        title: "Build",
        desc: "Fixed-scope first phase or time-and-materials with a cap. Production-grade code, not a prototype. Delivered into your cloud environment with tests, monitoring, and handoff documentation."
    },
    {
        step: "03",
        title: "Operate",
        desc: "4–8 week warranty period post-handoff. Bugs and regressions fixed at zero cost. Ongoing ops available — we don't disappear after delivery."
    }, 
];
function MethodologyAnchor() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-5xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-2",
                    children: "How an engagement works"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-gray-500 mb-10 text-base",
                    children: "No open-ended retainers. Every engagement starts with a bounded, fixed-price discovery."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-8",
                    children: steps.map(function(s) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col gap-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-3xl font-bold text-[#f1aa4e]",
                                    children: s.step
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-lg font-semibold text-gray-900",
                                    children: s.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-gray-600 text-sm leading-relaxed",
                                    children: s.desc
                                })
                            ]
                        }, s.step);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-10",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/itmtb-how-we-work",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "text-blue-600 font-semibold text-sm hover:underline",
                            children: "Full methodology and engagement shapes →"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 2100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuccessStoryEmbed; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2684);





var allCaseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_3__.filter(function(item) {
    var ref;
    return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
}).map(function(item) {
    return {
        title: item.meta.title || "",
        slug: item.meta.slug || "",
        img: item.meta.img || null,
        industry_descriptor: item.meta.industry_descriptor || null,
        outcome_metric: item.meta.outcome_metric || null,
        refer: Array.isArray(item.meta.refer) ? item.meta.refer : [],
        date: item.meta.date || ""
    };
});
function SuccessStoryEmbed(param) {
    var referTag = param.referTag, _maxItems = param.maxItems, maxItems = _maxItems === void 0 ? 3 : _maxItems, _heading = param.heading, heading = _heading === void 0 ? "Work we've shipped for clients like you" : _heading;
    var stories = referTag ? allCaseStudies.filter(function(s) {
        return s.refer.includes(referTag);
    }) : [];
    if (stories.length === 0) {
        stories = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(allCaseStudies).sort(function(a, b) {
            return b.date > a.date ? 1 : -1;
        });
    }
    var visible = stories.slice(0, maxItems);
    if (!visible.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-12 px-6 md:px-[60px] bg-gray-50 text-left",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-6xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-left",
                    children: heading
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-8",
                    children: visible.map(function(story) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/blog/".concat(story.slug),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "group bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-blue-400 hover:shadow-md transition-all flex flex-col",
                                children: [
                                    story.img && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative w-full h-44 bg-gray-100",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            src: story.img,
                                            alt: story.title,
                                            fill: true,
                                            className: "object-cover",
                                            sizes: "(max-width: 768px) 100vw, 400px",
                                            placeholder: "blur",
                                            blurDataURL: "/blogImages/hero/placeholder.webp"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "p-5 flex flex-col flex-1",
                                        children: [
                                            story.industry_descriptor && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-blue-500 text-xs uppercase tracking-wide font-medium mb-2",
                                                children: story.industry_descriptor
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors leading-snug mb-3 flex-1",
                                                children: story.title
                                            }),
                                            story.outcome_metric && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-auto pt-3 border-t border-gray-100",
                                                children: story.outcome_metric
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, story.slug);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/success-stories",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "inline-block border border-gray-300 hover:border-blue-500 text-gray-700 hover:text-blue-600 font-semibold px-7 py-3 rounded-lg transition-colors text-sm",
                            children: "See all success stories →"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 4518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Strategy; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1180);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2684);
/* harmony import */ var _components_services_Service2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3230);
/* harmony import */ var _components_trust_SuccessStoryEmbed__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2100);
/* harmony import */ var _components_services_MethodologyAnchor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(710);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2616);
/* harmony import */ var _components_services_ServiceEngagementLinks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5733);
/* harmony import */ var _components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4837);






var Capabilities2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5791), __webpack_require__.e(8388), __webpack_require__.e(5290), __webpack_require__.e(7517), __webpack_require__.e(7113)]).then(__webpack_require__.bind(__webpack_require__, 7517));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7517)
            ];
        }
    },
    ssr: false
});






var ContactUsHome = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 6245).then(__webpack_require__.bind(__webpack_require__, 6245));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6245)
            ];
        }
    },
    ssr: false
});
var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 2941).then(__webpack_require__.bind(__webpack_require__, 3193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3193)
            ];
        }
    },
    ssr: false
});
Strategy.title = "Technology Strategy Consulting — Discovery Sprint & AI Roadmap | ITMTB";
Strategy.desc = "ITMTB runs fixed-price discovery sprints that produce a written roadmap, cost estimate, and risk register in 2 weeks. No open-ended retainer required to get started.";
Strategy.header_img = "https://www.itmtb.com/services/capability/strategy_1.webp";
Strategy.keywords = "technology strategy consulting India, paid discovery sprint India, AI strategy consulting India, digital transformation roadmap India, IT strategy India 2-week fixed price, technology roadmap enterprise India";
var faqItems = [
    {
        q: "What is a discovery sprint and what does it produce?",
        a: "A discovery sprint is a fixed-scope, fixed-price engagement that produces three deliverables in two weeks: a written technical roadmap (what to build, in what order, with what technology choices); a cost and timeline estimate for the recommended build; and a risk register that documents the technical, data, and organisational risks that could delay or derail the project, with mitigation recommendations. The discovery sprint exists because most technology engagements fail not in execution but in scoping — ambiguous requirements, underestimated complexity, and unidentified dependencies. A two-week sprint forces the clarity that prevents expensive mid-project course corrections. At the end of the sprint, you decide whether to proceed with the build — there is no obligation beyond the sprint fee. We have run discovery sprints for fintechs processing over 1 million transactions per 15 hours, global supply chain firms managing 100,000+ SKUs, and D2C brands rebuilding their digital operations."
    },
    {
        q: "How do I know if my organisation is ready to deploy AI?",
        a: "The most reliable indicator of AI readiness is data accessibility — not data volume. Organisations that struggle with AI deployments almost always have the same root problem: the data the AI needs exists but can't be reliably retrieved. It's in a legacy system without an API, it's inconsistently formatted across sources, or it requires manual extraction. Before investing in model selection, prompt engineering, or AI platforms, the question to answer is: can we give an AI agent clean, structured, real-time access to the operational data it needs to act? If yes, you're ready to scope a use case. If no, data infrastructure comes first. We assess both dimensions during the discovery sprint: data readiness and use case fit. The output tells you specifically what's ready to automate now versus what requires a data infrastructure investment first."
    },
    {
        q: "What does an AI strategy for an Indian enterprise actually involve?",
        a: "An AI strategy for an Indian enterprise has three components that generalist AI strategy frameworks often miss. First, regulatory mapping: DPDP Act 2023 affects any AI system that processes personal data of Indian citizens; RBI guidelines affect AI in banking and payment systems; SEBI guidelines affect AI in capital markets. Any AI strategy that doesn't account for the regulatory layer will hit compliance blockers mid-build. Second, data infrastructure gap analysis: Indian enterprise data tends to be distributed across legacy systems (Tally, older SAP versions, proprietary industry software) that weren't designed for API access. The strategy has to include a data readiness roadmap alongside the AI use case roadmap. Third, use case prioritisation for the Indian cost structure: the ROI threshold for AI automation in India is different from the US because labour costs are lower. Use cases that are unambiguously worth automating at $150/hour blended rates may not be at Indian rates — the strategy should be explicit about this arithmetic."
    },
    {
        q: "What's the difference between a technology strategy and a digital transformation roadmap?",
        a: "A technology strategy is a set of decisions about what technology to use, how to organise technology investment, and what to build versus buy versus partner. It answers: what stack, what architecture, what capabilities in-house versus outsourced, what the 12–18 month build priority is. A digital transformation roadmap is broader: it includes the technology decisions but also the organisational changes, process redesigns, and change management required to make technology adoption stick. The roadmap typically covers 2–3 years and includes dependency sequencing — what has to happen before what else can happen. We produce technology strategy as the output of a discovery sprint. A digital transformation roadmap is produced for organisations with a more complex stakeholder environment or multi-business-unit scope — it takes longer and involves more workshops with different parts of the organisation."
    },
    {
        q: "How do you approach build vs. buy vs. partner decisions for enterprise software?",
        a: "We use a decision framework with three criteria. First, strategic differentiation: if the capability is a direct competitive differentiator (a proprietary risk model, a custom logistics platform, an AI feature that no competitor has), build — because owning the IP matters. If it's commodity infrastructure, buy or use a managed service. Second, total cost of ownership over 3 years, not just licence vs. development cost: custom-built solutions have ongoing maintenance costs; SaaS has escalating subscription costs and vendor lock-in risk. We build the 3-year TCO model for the material options. Third, data control: some AI use cases require keeping sensitive data in your own environment, which eliminates certain SaaS options regardless of cost. The discovery sprint produces a concrete build/buy/partner recommendation with the reasoning documented — not a generic 2\xd72 matrix."
    },
    {
        q: "How does ITMTB price an engagement?",
        a: "Pricing follows the engagement model. Discovery sprints are fixed-price for a fixed timebox. Build engagements are scoped after discovery — fixed-scope, time-and-materials, or outcome-linked. Managed services are billed monthly with defined SLAs. Total cost depends on scope, integration complexity, QA depth, and post-launch support — we publish a transparent breakdown for buyers evaluating their options.",
        link: "/blog/custom-software-development-cost-india",
        linkLabel: "Read the cost guide"
    },
    {
        q: "What does an engagement with ITMTB look like?",
        a: "Every engagement starts with a fixed-scope, fixed-price discovery sprint — typically 2 weeks. You leave with a written roadmap, risk register, cost estimate, and timeline before committing to a build. We then offer four engagement models: fixed-scope builds, time-and-materials, outcome-linked retainers, and managed services post-launch. If discovery doesn't justify proceeding, you can stop there — no obligation.",
        link: "/itmtb-how-we-work",
        linkLabel: "See how we work"
    }, 
];
Strategy.faq = faqItems;
function Strategy() {
    var insights = _blogs_json__WEBPACK_IMPORTED_MODULE_2__.filter(function(item) {
        var ref;
        return ![
            "case-study",
            "tech"
        ].includes(item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category);
    });
    var caseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_2__.filter(function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
    });
    var filteredInsights = insights.filter(function(item) {
        var ref, ref1;
        return item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("Strategy");
    });
    var filteredCaseStudies = caseStudies.filter(function(item) {
        var ref, ref1;
        return item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("Strategy");
    });
    if (filteredInsights.length === 1) {
        insights = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(filteredInsights).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__/* .getRandom */ .s)(insights.filter(function(item) {
            return !filteredInsights.includes(item);
        }), 1)));
    } else if (filteredInsights.length >= 2) {
        insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__/* .getRandom */ .s)(filteredInsights, 2);
    } else {
        insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__/* .getRandom */ .s)(insights, 2);
    }
    if (filteredCaseStudies.length === 1) {
        caseStudies = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(filteredCaseStudies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__/* .getRandom */ .s)(caseStudies.filter(function(item) {
            return !filteredCaseStudies.includes(item);
        }), 1)));
    } else if (filteredCaseStudies.length >= 2) {
        caseStudies = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__/* .getRandom */ .s)(filteredCaseStudies, 2);
    } else {
        caseStudies = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__/* .getRandom */ .s)(caseStudies, 2);
    }
    var subServices = [
        {
            img: null,
            key: "Discovery Sprint — Two Weeks, Fixed Price",
            title: "Roadmap, cost estimate, and risk register. You decide whether to build. No obligation beyond the sprint.",
            text: "Before committing to a build, you get clarity on exactly what to build, how long it will take, what it will cost, and what could go wrong. The discovery sprint forces that clarity into writing in two weeks.\n\nWe have run discovery sprints for fintechs processing over 1 million transactions per 15 hours, global supply chain firms, and D2C brands. The output is a document you can act on immediately — or use to evaluate other vendors."
        },
        {
            img: null,
            key: "AI Strategy and Use Case Roadmap",
            title: "Which workflows are worth automating, which aren't, and what you need in place before the build starts.",
            text: "An AI strategy grounded in your actual operations, not vendor pitch decks. We assess use case fit (is this process structured enough, high-volume enough, and data-accessible enough to be worth automating?), data readiness (can an AI agent reach the data it needs?), and regulatory implications (DPDP, RBI, SEBI where applicable).\n\nOutput: a prioritised use case list with ROI estimates, data readiness gaps, and a sequenced build roadmap."
        },
        {
            img: null,
            key: "Technology Stack Audit",
            title: "An independent assessment of what you have, what it can do, and what you should change.",
            text: "We audit existing technology stacks for enterprises considering a major investment: pre-AI deployment (is the current stack ready?), pre-acquisition (what is the technical liability?), or pre-rebuild (is a rebuild actually warranted?).\n\nOutput: a written assessment covering architecture, security posture, scalability limits, technical debt inventory, and a prioritised list of changes with estimated effort — the same format as the discovery sprint deliverable."
        },
        {
            img: null,
            key: "Digital Transformation Roadmap",
            title: "Technology decisions plus the organisational sequencing required to make adoption stick.",
            text: "For organisations with multi-business-unit scope or complex stakeholder environments, a technology strategy alone isn't sufficient — the roadmap needs to include process redesign, change management dependencies, and a realistic sequencing of what happens before what.\n\nWe produce transformation roadmaps for 12–24 month horizons, with quarterly milestones and explicit dependency mapping — so leadership can track progress and adjust investment based on results."
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "ProfessionalService",
                            name: "Technology Strategy Consulting — Discovery Sprint & AI Roadmap India",
                            url: "https://www.itmtb.com/services/strategy",
                            image: "https://www.itmtb.com/services/capability/strategy_1.webp",
                            description: "ITMTB runs fixed-price discovery sprints that produce a written roadmap, cost estimate, and risk register in 2 weeks. No open-ended retainer required to get started.",
                            provider: {
                                "@type": "Organization",
                                name: "ITMTB Technologies",
                                url: "https://www.itmtb.com",
                                logo: "https://www.itmtb.com/logo.webp"
                            },
                            areaServed: [
                                {
                                    "@type": "Place",
                                    name: "India"
                                }
                            ],
                            serviceType: [
                                "Technology Strategy Consulting India",
                                "Paid Discovery Sprint",
                                "AI Strategy Consulting India",
                                "Digital Transformation Roadmap",
                                "IT Strategy Consulting India",
                                "Technology Roadmap Enterprise India",
                                "AI Readiness Assessment",
                                "Risk Register and Cost Estimation", 
                            ],
                            sameAs: [
                                "https://www.linkedin.com/company/itmtb-technologies/",
                                "https://x.com/ITMTBTech",
                                "https://www.instagram.com/itmtbtech/", 
                            ]
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_Service2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                heading: "Technology Strategy and Discovery",
                paragraph: "Two weeks. Fixed price. Roadmap, cost estimate, and risk register — or you walk.\n\nMost technology projects fail in scoping, not execution: ambiguous requirements, underestimated complexity, and risks nobody documented until they became blockers. A discovery sprint forces that clarity into writing before you commit to a build.\n\nWe audited the complete tech stack of a fintech processing over 1 million transactions every 15 hours — and delivered actionable findings within a 2-week fixed-scope engagement. The same sprint format works for AI use case scoping, pre-build technology audits, and digital transformation roadmaps.",
                bgPath: "/services/capability/strategy_1.webp",
                primaryCta: {
                    label: "Talk to us →",
                    href: "/contact-us"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_trust_SuccessStoryEmbed__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                referTag: "Strategy",
                maxItems: 3,
                heading: "Selected work in strategy and advisory"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_9__/* .CustomerSection */ .a, {
                title: "Trusted by"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_MethodologyAnchor__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Capabilities2, {
                dataList: subServices,
                bg: "bg-[#402A6A]",
                insights: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(caseStudies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(insights)),
                hideFooter: true,
                hideCardSubtitle: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                items: faqItems
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceEngagementLinks__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactUsHome, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {})
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,8657,2684,1831,9774,2888,179], function() { return __webpack_exec__(9817); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);